// extracted by mini-css-extract-plugin
export var chevron = "_20-d";
export var disabled = "_20-b";
export var error = "_20-c";
export var hideBorder = "_20-1";
export var icon = "_20-e";
export var input = "_20-0";
export var large = "_20-f";
export var open = "_20-9";
export var placeholder = "_20-a";
export var regular = "_20-5";
export var singleRowInput = "_20-2";
export var singleSelectInput = "_20-3 _20-0";
export var small = "_20-4";
export var spinnerContainer = "_20-i";
export var tag = "_20-7";
export var tagsContainer = "_20-8";
export var tagsInput = "_20-6 _20-0";
export var xSmall = "_20-g";
export var xxSmall = "_20-h";